<script lang="ts">
	import { smartContractWalletAddress, smartWalletName } from './store';
	import { addDollarSign, getNumBackInUnits } from '$lib/util/util';

	import { scale } from 'svelte/transition';
	import { quintOut } from 'svelte/easing';
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import { userMarginBalanceForTrade } from '../userInteract/store';
	import Tooltip from '$lib/tooltip/Tooltip.svelte';
</script>

<div class="">
	<div class="flex justify-center h-44">
		<img
			src={'scwallet/wallet-icon.webp'}
			loading="lazy"
			class="max-w-max"
			in:scale={{ duration: 250, delay: 0, opacity: 0.5, start: 0.9, easing: quintOut }}
			alt="Wallet Icon"
		/>
	</div>
	<div class="flex items-center justify-center -mt-14">
		<GradientBorder
			gradient="bg-fx-gradient-14"
			paddingClass="p-px"
			borderRadius="rounded-lg squircle-lg"
			outerClassList=""
			innerClassList="flex justify-center items-center bg-fx-black"
		>
			<div class="bg-fx-gradient-6 text-fx-white py-1 px-2.5 rounded-lg squircle-lg">
				<div class="text-fx-gradient-5">
					{$smartWalletName}
				</div>
			</div>
		</GradientBorder>
	</div>
	<div class="text-center">
		<div class="text-fx-gradient-23 font-semibold text-2xl mt-4">
			{#if $smartContractWalletAddress && $userMarginBalanceForTrade}
				<Tooltip
					title="Sum of USD balance and margins in your smart wallet"
					header="Cumulative Smart Wallet Balance"
				>
					{addDollarSign(getNumBackInUnits($userMarginBalanceForTrade, 18, 2))}
				</Tooltip>
			{:else}
				<div
					class="animate-pulse bg-fx-grey-800 h-10 col-span-2 rounded-lg squircle-lg w-20 mx-auto"
				/>
			{/if}
		</div>
	</div>
</div>
